export default __webpack_public_path__ + "static/media/bangLogo.8b1e6409.png";